import CreateObjectiveDialog from './CreateObjectiveDialogContainer';

export default CreateObjectiveDialog;
